import { isUndefinedOrNull } from '../../TypeHelpers';
import where from './where';
export default function firstOrDefault(iterable, predicate) {
    if (!isUndefinedOrNull(predicate)) {
        iterable = where(iterable, predicate);
    }
    for (const item of iterable) {
        return item;
    }
    return null;
}
